// extracted by mini-css-extract-plugin
export var card = "Speakers-module--card--94e5d";
export var component = "Speakers-module--component--45aad";
export var content = "Speakers-module--content--6ae1d";
export var contentArea = "Speakers-module--contentArea--96152";
export var fadePop = "Speakers-module--fade-pop--b3c0a";
export var fullWidth = "Speakers-module--fullWidth--973c4";
export var grid = "Speakers-module--grid--b3346";
export var growHeightIn = "Speakers-module--grow-height-in--58c1a";
export var keyContact = "Speakers-module--keyContact--43a1a";